import styled from "styled-components";

export const LastLoginAndSessionTimerBox = styled.div`
    display: flex;
    gap: 10px;

    @media ${({ theme }) => theme.mediaQuery.mAndBelow} {
        align-items: center;
        height: 100%;
    }

    @media ${({ theme }) => theme.mediaQuery.lAndAbove} {
        flex-direction: column;
    }
`;

export const LastLoginAndSessionTimerDefaultBox = LastLoginAndSessionTimerBox;